/*
 * @Author: Ryan
 * @Date: 2026-01-08
 * @Description: 视频翻译 Landing 页面配置
 */

import { LanguageCode } from '@/hooks/useTranslationConfig';

// 功能页跳转路径
export const VIDEO_TRANSLATOR_URL = '/video-translator';

export interface LandingPageConfig {
  slug: string;
  jsonFileName: string;
  sourceLanguage: LanguageCode;
  targetLanguage: LanguageCode;
}

// 所有 Landing 页面配置（暂时只保留 spanish-to-english）
export const LANDING_PAGES: LandingPageConfig[] = [
  {
    slug: 'spanish-to-english',
    jsonFileName: 'spanish-to-english.json',
    sourceLanguage: 'es',
    targetLanguage: 'en',
  },
];

// 根据 slug 获取配置
export const getLandingConfig = (slug: string): LandingPageConfig | undefined => {
  return LANDING_PAGES.find((page) => page.slug === slug);
};

// 获取所有 slug（用于 getStaticPaths）
export const getAllSlugs = (): string[] => {
  return LANDING_PAGES.map((page) => page.slug);
};
